export { default } from './EditHoldDatesBatchActions';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/EditHoldDatesBatchActions/index.js